<script lang="ts">
export default {
  name: 'KkFormLabel',
}
</script>

<script lang="ts" setup>
export interface Props {
  text: string
  htmlFor?: string
}

const props = defineProps<Props>()
</script>

<template>
  <component
    :is="props.htmlFor ? 'label' : 'div'"
    :for="props.htmlFor || null"
    class="formLabel"
  >
    {{ props.text }}
  </component>
</template>

<style lang="scss" scoped>
.formLabel {
  display: inline-block;
  font-weight: bold;
  font-size: 12px;
  line-height: 1;
  letter-spacing: 1px;
}
label.formLabel {
  cursor: pointer;
}
</style>
